/**
 * @author varun
 */

angular.module("jv.Common.Directives.PageRefresh", [])
	.directive('pageRefresh', function($window, $rootScope, $timeout, $log){
	return{
		restrict: 'A',
		link: function(scope, element, attribute){

			//Set up the logging
			var ifLogPageRefresh = false;
			if(typeof attribute['logRefresh'] !== 'undefined' && (attribute['logRefresh'] === 'true' || attribute['logRefresh'] === true)){
				ifLogPageRefresh = true;
				if(window.localStorage && window.localStorage["onunloadmessage"] != ''){
					logRefresh(window.localStorage["onunloadmessage"]);
					window.localStorage["onunloadmessage"] = '';
				}
			}
			// log errors.
			function logRefresh(message){
				if(ifLogPageRefresh){
					if(message == undefined){
						$log.error("PAGE REFRESH: "+ attribute['otherData']);
					}else{
						$log.error(message);
					}
					//TODO: get the details about the interview and try to log them
					
				}
			}

			scope.$on("$destroy", function(){
		        //unbind the event.
				$window.onbeforeunload=null; 
		    });

			var message = attribute.message;
			scope.$on("$locationChangeStart", function(event){
				logRefresh();
				if(scope.showOnUnloadMessage===undefined || scope.showOnUnloadMessage===true || scope.showOnUnloadMessage==="true"){
					var response = confirm(attribute['message']);
					if(!response){
						event.preventDefault();
					}
				}
			});

			$window.onbeforeunload = function() {
				logRefresh();
				if(window.localStorage){
					window.localStorage["onunloadmessage"] = '';
				}
				if(scope.showOnUnloadMessage===undefined || scope.showOnUnloadMessage===true || scope.showOnUnloadMessage==="true"){
					return message;	
				}	    
			}

			$window.onunload = function(event){
				if(window.localStorage){
					window.localStorage["onunloadmessage"] = "FORCE UNLOAD: PAGE REFRESH :" + attribute['otherData'];
				}
			}
		}	
	}
});
